import { deleteCookie, getCookie, setCookie } from 'utils/cookie'
import { MortgageRateTableDimensions } from '@bankrate/mortgage-types'

/**
 * This fn sets a cookie that is used to pre-fill answers on the CPL form
 * based on info the user has already provided to the rate-table
 */
export const setPreFillCookie = (dimensions: MortgageRateTableDimensions, downPaymentPercentage: number) => {
  let preFillData: object = {
    productType: dimensions.mortgageType,
    zipcode: dimensions.zipCode,
    purchasePrice: dimensions.purchase.price,
    downPayment: dimensions.purchase.downPayment,
    downPaymentPercentage,
    propertyValue: dimensions.refinance.propertyValue,
    currentLoanBalance: dimensions.refinance.loanAmount,
  }
  const email = getCookie('email')
  deleteCookie('email')
  if (email) {
    preFillData = { ...preFillData, email }
  }
  setCookie('modifiedFields', JSON.stringify(preFillData))
}
